import React from 'react';
import ListLayout from '@presentation/layouts/ListLayout';
import Categories from '@presentation/pages/Categories';

import { makeCollectionService } from '../makeCollectionService';

const makeCategories = (firstPage: any) => {
	// TODO add valid type
	const collectionsService = makeCollectionService();

	return (
		<ListLayout>
			<Categories firstPage={firstPage} collectionsService={collectionsService} />
		</ListLayout>
	);
};

export default makeCategories;
